import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

export const updateCheckoutTree = {
  name: "updateCheckoutTree" as const,
  input: z.object({
    steps: checkoutOptimizationStepArraySchema,
    updateTreatments: z.boolean(),
  }),
  output: z.null(),
};
